import { Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ReportingService } from 'src/app/shared/store/reporting/reporting.service';

@Component({
    selector: 'app-home-layout',
    templateUrl: './home-layout.component.html',
    styleUrls: ['./home-layout.component.scss'],
    standalone: false
})
@UntilDestroy()
export class HomeLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
